import React from "react";
import {useNavigate} from "react-router-dom";
import {Button, Card, List} from "antd";
import {TagOutlined} from "@ant-design/icons";

import PageTitle from "../../../../components/page/PageTitle";
import ErrorBoundary from "../../../../components/ErrorBoundary";
import {messageType, showMessages} from "../../../../helpers/message";
import {useAppDispatch, useAppSelector} from "../../../../hooks/useStore";
import {selectCurrentProfile, selectIsStaff, setActiveMember} from "../../../../store/slices/userSlice";
import {Profile} from "../../../../types/accountTypes";

import {listGridStyle} from "../../../../assets/styles";

const ProfileChange = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const userIsStaff = useAppSelector(selectIsStaff);
    const profiles = useAppSelector(state => state.user.profiles);
    const currentProfile = useAppSelector(selectCurrentProfile);

    React.useEffect(() => {
        // Restrict ProfileChange page to member with multi profiles.
        if (profiles.length <= 1 || userIsStaff) navigate('/');
    }, [profiles, navigate, userIsStaff]);

    const selectProfile = (profile: Profile) => {
        dispatch(setActiveMember(profile));
        showMessages('Profile changed successfully!', messageType.success);

        if (profile.membership !== null) {
            navigate('/account/account_info');
        } else { // If the profile being changed to has inactive membership, redirect to personal info page.
            navigate('/profile/personal_info');
        }
    };

    return (
        <>
            <PageTitle title="Select Profile"/>
            <ErrorBoundary>
                <List
                    grid={{...listGridStyle}}
                    dataSource={profiles}
                    renderItem={
                        profile => {
                            const {account, membership, company} = profile;
                            const isCurrentProfile = profile.id === currentProfile?.id;

                            let accountMembershipNumber = 'Inactive';
                            if (account && membership) {
                                accountMembershipNumber = account.account_number + '-' + membership.membership_number;
                            }

                            let isBusiness = (account && account.is_business) ? 'Business' : 'Personal';
                            let companyName = company ? company : null;
                            return (
                                <List.Item>
                                    <Card
                                        title={accountMembershipNumber}
                                        extra={isCurrentProfile && <TagOutlined/>}
                                    >
                                        <Card.Meta
                                            title={<span className="long-text-wrap">{isBusiness}</span>}
                                            description={
                                                <>
                                                    <p>{companyName}</p>
                                                    <p>{isCurrentProfile && "Current Profile"}</p>
                                                    <Button
                                                        type="primary"
                                                        onClick={() => selectProfile(profile)}
                                                        disabled={isCurrentProfile}
                                                    >
                                                        Select Profile
                                                    </Button>
                                                </>
                                            }
                                        />
                                    </Card>
                                </List.Item>
                            )
                        }
                    }
                />
            </ErrorBoundary>
        </>
    )
};

export default ProfileChange;
